<template>
  <q-section v-bind="$attrs" :pt="statusBarHeight" @click="back"></q-section>
</template>

<script setup lang="ts">
import { requestApp } from '@/core/bridge'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const statusBarHeight = ref<any>(27)
onMounted(async () => {
  try {
    statusBarHeight.value = await requestApp('ucoo_status_bar_height')
  } catch (e) {
    console.log(e)
  }
})
const back = () => {
  // 判断路由栈长度
  if (router.options.history.state.back) {
    router.back()
  } else {
    requestApp('ucoo_finish')
  }
}
</script>

<style scoped lang="scss"></style>
